<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class VersionMixin extends Vue {
  public getPathName(v: string) {
    return `/releaseNotes/${v}_releaseNote_${this.$i18n.locale || 'en'}.pdf`;
  }
}

</script>

<style></style>
